import * as React from 'react';

import { AlertsMenu } from '../header/AlertsMenu';
import { PageHeaderFavoritesDropdown } from '../header/FavoritesDropdown';
import { HeaderStyles } from '../header/HeaderStyles';
import { HelpMenu } from '../header/HelpMenu';
import { UserMenu } from '../header/UserMenu';
import { SpacesSiteUrls } from '../spaces/SpacesSiteUrls';
import { PageHeaderButtonType, RightItem } from './PageHeader';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { NotificationCenter } from '../../userNotifications/components/NotificationCenter';

export interface PageHeaderMenusStateProps {
  readonly inServerArea: boolean;
  readonly inSiteArea: boolean;
  readonly inSiteContentArea: boolean;
  readonly siteUrls: SpacesSiteUrls;
}

export interface PageHeaderMenuOwnProps {
  readonly buttonType: PageHeaderButtonType;
  readonly showFavoritesMenu: boolean;
}

export type PageHeaderMenusProps = PageHeaderMenusStateProps & PageHeaderMenuOwnProps;

const MenuButtonStyle: React.CSSProperties = {
  verticalAlign: 'top',
  lineHeight: HeaderStyles.TopBarLineHeight
};


export function PageHeaderMenus(props: Readonly<PageHeaderMenusProps>): JSX.Element {

  return (
    <React.Fragment>

      { props.showFavoritesMenu && <RightItem>{ renderFavoritesDropdown(props) }</RightItem> }
      <RightItem>{ renderHelpMenu(props) }</RightItem>
      { !FeatureFlags.userNotificationCenterEnabled && props.inSiteArea && <RightItem>{ renderAlertsMenu(props) }</RightItem> }
      { FeatureFlags.userNotificationCenterEnabled && props.inSiteArea && <RightItem>{renderNotificationCenter(props)} </RightItem> }
      <RightItem>{ renderUserMenu(props) }</RightItem>

    </React.Fragment>
  );
}

function renderAlertsMenu(props: PageHeaderMenusProps) {
  return <AlertsMenu
    key="alerts"
    style={MenuButtonStyle}
    buttonType={props.buttonType}
  />;
}

function renderNotificationCenter(props: PageHeaderMenusProps) {
  return <NotificationCenter
    key="notifications"
    buttonType={props.buttonType}
  />;
}

function renderHelpMenu(props: PageHeaderMenusProps) {
  return <HelpMenu
    key="help"
    style={MenuButtonStyle}
    buttonType={props.buttonType}
  />;
}


function renderUserMenu(props: PageHeaderMenusProps) {
  return <UserMenu
    key="user"
    style={MenuButtonStyle}
    inServerArea={props.inServerArea}
    inSiteContentArea={props.inSiteContentArea}
  />;
}

function renderFavoritesDropdown(props: PageHeaderMenusProps) {
  return <PageHeaderFavoritesDropdown
    key="favorites"
    siteUrls={props.siteUrls}
  />;
}
